module.exports = __webpack_public_path__ + "static/media/RI-D4-0.4-083.f09f48c3.webp";